<template>
    <b-modal
        v-model="isComponentModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal
    >
        <template #default="props">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title"></p>
                    <button
                        type="button"
                        class="delete"
                        @click="props.close"
                    />
                </header>
                <section class="modal-card-body">
                    <plan :education-plan-id="educationPlanId" :editable="false" ref="plan" />
                </section>
                <footer class="modal-card-foot">
                    <b-button
                        label="Закрыть"
                        @click="props.close" />
                </footer>
            </div>
        </template>
    </b-modal>
</template>
<script>


import Plan from '../show/Plan'
export default {
    props: {
        educationPlanId: {
            default: null,
            required: true,
        },

    },
    components: {
        Plan,
    },
    data() {
        return {
            disabled: false
        }
    },
    computed: {
        isComponentModalActive: {
            get() {
                return this.educationPlanId !== null
            },
            set(val) {
                if(!val) this.$emit('update:educationPlanId', null)
            }
        },
    },
}
</script>